import { motion } from "framer-motion";
import { MessageSquare, PencilRuler, Code2, Rocket } from "lucide-react";

const steps = [
  {
    icon: MessageSquare,
    title: "Discovery Call",
    desc: "Free 20-min consultation to scope your goals, audience, and conversions.",
  },
  {
    icon: PencilRuler,
    title: "Design Sprint",
    desc: "We deliver a custom design within 1–2 days. Two revision rounds included.",
  },
  {
    icon: Code2,
    title: "Build & Launch",
    desc: "Pixel-perfect development, performance tuning, content + hosting setup.",
  },
  {
    icon: Rocket,
    title: "Grow & Maintain",
    desc: "Ongoing optimization, A/B testing, and maintenance plans on standby.",
  },
];

export default function Process() {
  return (
    <section id="process" className="section-pad relative bg-[#070707]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <span className="font-mono-jb text-xs uppercase tracking-[0.3em] text-[#CCFF00]">
                / How it works
              </span>
              <h2 className="font-display text-4xl sm:text-5xl tracking-tighter font-bold mt-4 leading-[1.05]">
                From idea to launch in <span className="text-gradient-neon">2–5 days.</span>
              </h2>
              <p className="text-zinc-400 mt-5 leading-relaxed">
                A proven four-step process built around fast feedback loops
                and clear deliverables — no agency runaround.
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-8 space-y-4">
            {steps.map((s, i) => (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="bento-card p-6 md:p-8 flex items-center gap-6"
                data-testid={`process-step-${i}`}
              >
                <div className="font-display text-5xl md:text-6xl font-black text-[#CCFF00]/30 w-14 shrink-0">
                  0{i + 1}
                </div>
                <div className="w-12 h-12 rounded-xl bg-[#CCFF00]/10 border border-[#CCFF00]/30 flex items-center justify-center shrink-0">
                  <s.icon className="w-5 h-5 text-[#CCFF00]" />
                </div>
                <div>
                  <h3 className="font-display text-xl md:text-2xl font-bold">
                    {s.title}
                  </h3>
                  <p className="text-zinc-400 mt-1">{s.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
